import React from 'react';

// AnnouncementBanner disabled — stealth mode
export default function AnnouncementBanner() {
  return null;
}
